<!-- @format -->

<img
	#img
	[alt]="altText()"
	[disableOptimizedSrcset]="false"
	[loaderParams]="imageLoaderConfig().loaderParams"
	[ngSrc]="imageLoaderConfig().src"
	[priority]="isPriority()"
	[attr.loading]="loadingStrategy()"
	[sizes]="$safeNavigationMigration(imageLoaderConfig().loaderParams?.sizes)"
	fill
	(error)="handleImageError(img.src)"
	(load)="optimizedImageLoaded.emit($event)"
	[attr.itemprop]="imageItemProp()"
/>

